import clsx, {ClassValue} from "clsx";
import {twMerge} from "tailwind-merge";

/**
 * Combines the clsx and tailwind-merge utilities.
 *
 * clsx enables the use of list and object syntax for class names.
 * See https://www.npmjs.com/package/clsx.
 *
 * tailwind-merge enables the merging of lists of Tailwind classes without conflicts.
 * See https://www.npmjs.com/package/tailwind-merge.
 *
 * Example usage:
 *
 * <div className={clsMerge(
 *    "text-green-500 text-2xl font-bold",
 *    isBlue && "text-navy-500",
 *    customClassName
 *  )} />
 *
 * @param inputs - The class names to merge
 */
const clsMerge = (...inputs: ClassValue[]) => twMerge(clsx(...inputs));

export default clsMerge;
